import type { CampaignReportRow, CampaignStatusName } from "@multi-chat/shared";

export function formatCampaignReportRate(rate: number | null, locale: string): string {
  if (rate == null) return "—";
  return new Intl.NumberFormat(locale, {
    style: "percent",
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
  }).format(rate);
}

export function campaignReportSenderPrimary(row: CampaignReportRow): string {
  const sender = row.sender;
  if (!sender) return "—";
  const name = sender.displayName?.trim();
  if (name) return name;
  return sender.phoneNumber?.trim() || "—";
}

export function campaignReportSenderSecondary(row: CampaignReportRow): string | null {
  const sender = row.sender;
  if (!sender) return null;
  const name = sender.displayName?.trim();
  const phone = sender.phoneNumber?.trim();
  if (name && phone) return phone;
  return null;
}

export function campaignStatusLabelKey(status: CampaignStatusName): string {
  return `campaigns.status.${status}`;
}

export function showingCampaignRangeBounds(
  page: number,
  pageSize: number,
  total: number,
): { start: number; end: number } {
  if (total === 0) return { start: 0, end: 0 };
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return { start, end };
}
